import {apiFuns} from "sw-hic"
let {genStandard} = apiFuns
const api = {
  Consultation: genStandard("consultation", "/api/ip"),
  Hospitalization: genStandard("hospitalization", "/api/ip"),
  AdvicePackage:genStandard("advicePackage", "/api/ip"),
  Staff: genStandard("staff", "/api/md", true),


}
export default api;